import type { RoundSnapshot } from "../../domain/round/round-types.js";
import { roundJournal } from "../data/local-database.js";
import type { ActionContext } from "./round-workspace-sync.js";

export function correctionActions(
  accountId: string,
  current: () => ActionContext | null,
) {
  return {
    acceptRecordedSnapshot: (next: RoundSnapshot) =>
      acceptRecordedCorrection(accountId, next, current),
  };
}

/** Result corrections use the same acknowledged journal path as live updates. */
export async function acceptRecordedCorrection(
  accountId: string,
  next: RoundSnapshot,
  current: () => ActionContext | null,
): Promise<void> {
  const context = current();
  const snapshot = context?.snapshot;
  if (
    !context ||
    context.accountId !== accountId ||
    !snapshot ||
    snapshot.roundId !== next.roundId ||
    snapshot.schemaVersion !== next.schemaVersion
  ) {
    throw new Error("The active round changed. Reopen its score review.");
  }
  if (next.version <= snapshot.version) return;
  const accepted = await roundJournal.acceptLiveSnapshot(accountId, next);
  const latest = current();
  if (
    latest?.accountId !== accountId ||
    latest.snapshot?.roundId !== next.roundId
  )
    return;
  const recorded = accepted
    ? next
    : await roundJournal.getSnapshot(accountId, next.roundId);
  if (
    !recorded ||
    recorded.version < next.version ||
    (await roundJournal.listQueued(accountId, next.roundId)).length
  ) {
    throw new Error(
      "The scores changed while reviewing. Close this panel and check the latest result.",
    );
  }
  if (current()?.accountId !== accountId) return;
  latest.setSnapshot((value) =>
    value?.roundId === recorded.roundId && value.version <= recorded.version
      ? recorded
      : value,
  );
}
